import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, TextField, Grid, Paper, MenuItem, Typography, IconButton,InputAdornment,   Autocomplete, Modal, Box } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import PaymentIcon from '@mui/icons-material/Payment';
import CloseIcon from '@mui/icons-material/Close';
import Swal from "sweetalert2";
import api from "../api";
//import axios from 'axios';


const StudentBill = () => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [classList, setClassList] = useState([]);
    const [sections, setSections] = useState([]);
    const [rolls, setRolls] = useState([]);
    const [selectedClass, setSelectedClass] = useState("");
    const [selectedSection, setSelectedSection] = useState("");
    const [selectedRoll, setSelectedRoll] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [student, setStudent] = useState(null);
    const [fees, setFees] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [selectedFee, setSelectedFee] = useState(null);
    const [paidFees, setPaidFees] = useState([]);
    const [payments, setPayments] = useState([]);

    const [paymentMode, setPaymentMode] = useState("");
    const [utrNumber, setUtrNumber] = useState("");
    const [totalDays, setTotalDays] = useState(0);
    const [filteredFees, setFilteredFees] = useState([]);

    useEffect(() => {
    const token = localStorage.getItem("token");
    const storedUser = {
        id: localStorage.getItem("id"),
        user_id: localStorage.getItem("user_id"),
        name: localStorage.getItem("name"),
        mobile: localStorage.getItem("mobile"),
        role: localStorage.getItem("role"),

    };

    if (!token) {
        navigate("/login");
    } else {
        setUser(storedUser);
    }
    }, []);

    // ✅ Handle Payment Submission
    // const handleSubmit = () => {
    //     if (!selectedFee || !paymentMode) {
    //         Swal.fire({ icon: "warning", title: "Oops...", text: "Please select a payment mode!" });
    //         return;
    //     }

    //     let feeType = selectedFee.id;
    //     let amount = selectedFee.amount;

    //     if (selectedFee.fee_type.includes("Monthly Fees")) {
    //         feeType = "monthly_fees";
    //     }

    //     // ✅ যদি month_id thake tahole use করো, না থাকলে current month use করো
    //     const monthId = selectedFee.month_id ? selectedFee.month_id : (new Date().getMonth() + 1).toString().padStart(2, '0');

    //     const formattedMonth = `${new Date().getFullYear()}-${monthId}`;

    //     const paymentData = {
    //         student_id: selectedFee.student_id,
    //         class_id: selectedFee.class_id,
    //         fee_type: feeType,
    //         amount,
    //         payment_mode: paymentMode,
    //         utr_number: paymentMode === "upi" ? utrNumber : "",
    //         collected_by: user?.id,
    //         payment_month: formattedMonth, // ✅ "YYYY-MM" ফরম্যাট পাঠানো হচ্ছে
    //     };

    //     console.log("✅ Sending Payment Data:", paymentData);

    //     fetch("https://dgps.co.in/api/student-payment", {
    //         method: "POST",
    //         headers: { "Content-Type": "application/json", "Accept": "application/json" },
    //         body: JSON.stringify(paymentData),
    //     })
    //         .then(response => response.json())
    //         .then(data => {
    //             if (data.status) {
    //                 Swal.fire({
    //                     icon: "success",
    //                     title: "Payment Successful",
    //                     text: `₹ ${amount} has been paid successfully!`,
    //                     confirmButtonColor: "#3f51b5",
    //                 });

    //                 setOpenModal(false);
    //                 setPaymentMode("");
    //                 setUtrNumber("");

    //                 // ✅ Update Paid Fees Properly
    //                 setPaidFees(prevPaidFees => [
    //                     ...prevPaidFees, 
    //                     selectedFee.id  // ✅ নির্দিষ্ট মাসের ID সংযুক্ত হচ্ছে
    //                 ]);
                    
    //             } else {
    //                 throw new Error(data.message);
    //             }
    //         })
    //         .catch(error => {
    //             Swal.fire({
    //                 icon: "error",
    //                 title: "Payment Failed",
    //                 text: error.message || "Something went wrong. Please try again.",
    //             });
    //             setOpenModal(false);
    //         });
    // };


    /* ... component state declarations (user, selectedFee, paymentMode, utrNumber, setOpenModal, setPaidFees ইত্যাদি) ... */

    const handleSubmit = async () => {
    // validation
    if (!selectedFee || !paymentMode) {
        Swal.fire({ icon: "warning", title: "Oops...", text: "Please select a payment mode!" });
        return;
    }

    try {
        // determine feeType & amount
        let feeType = selectedFee.id;
        let amount = Number(selectedFee.amount || 0);

        // If selectedFee is monthly-fee card (label contains "Monthly Fees - MonthName")
        const isMonthlyFromLabel = typeof selectedFee.fee_type === "string" && selectedFee.fee_type.includes("Monthly Fees");
        if (isMonthlyFromLabel) {
        feeType = "monthly_fees";
        }

        // monthId: if selectedFee has month_id use it, otherwise detect month from fee label or fallback to current
        let monthId = selectedFee.month_id ?? null;
        if (!monthId && isMonthlyFromLabel) {
        // try extract month name from the fee_type like "Monthly Fees - March"
        const parts = (selectedFee.fee_type || "").split("-");
        if (parts.length > 1) {
            const monthName = parts[1].trim(); // e.g. "March"
            const monthIndex = ["January","February","March","April","May","June","July","August","September","October","November","December"].findIndex(m => m.toLowerCase() === monthName.toLowerCase());
            if (monthIndex >= 0) monthId = String(monthIndex + 1).padStart(2, "0");
        }
        }
        if (!monthId) {
        monthId = (new Date().getMonth() + 1).toString().padStart(2, "0");
        }

        const formattedMonth = `${new Date().getFullYear()}-${monthId}`;

        const paymentData = {
        student_id: selectedFee.student_id,
        class_id: selectedFee.class_id ?? selectedFee.classId ?? null,
        fee_type: feeType,
        amount,
        payment_mode: paymentMode,
        utr_number: paymentMode === "upi" ? (utrNumber || "") : "",
        collected_by: user?.id,
        payment_month: formattedMonth
        };

        console.log("Sending paymentData:", paymentData);

        // Use axios instance with interceptors
        const res = await api.post("/student-payment", paymentData);

        // API should return { status: true, ... } on success
        if (res?.data?.status) {
        Swal.fire({
            icon: "success",
            title: "Payment Successful",
            text: `₹ ${amount} has been paid successfully!`,
            confirmButtonColor: "#3f51b5",
        });

        // close modal + reset inputs
        setOpenModal(false);
        setPaymentMode("");
        setUtrNumber("");

        // Update paidFees:
        // For monthly payments, we push the special id format used elsewhere: monthly_fees_<MM>
        if (feeType === "monthly_fees") {
            const paidId = `monthly_fees_${parseInt(monthId, 10)}`; // e.g. "monthly_fees_03"
            setPaidFees(prev => {
            if (prev.includes(paidId)) return prev;
            return [...prev, paidId];
            });
        } else {
            // For one-time fees push fee id as string
            const ft = String(selectedFee.id);
            setPaidFees(prev => {
            if (prev.includes(ft)) return prev;
            return [...prev, ft];
            });
        }

        // Optionally: update local payments list for UI (if you store payments)
        // setPayments(prev => [...prev, res.data.payment || { ... }]);

        } else {
        // API returned status false
        const msg = res?.data?.message || "Payment failed. Please try again.";
        throw new Error(msg);
        }

    } catch (err) {
        console.error("Payment error:", err);
        // Axios error may be in err.response.data.message
        const message = err?.response?.data?.message || err?.message || "Something went wrong. Please try again.";
        Swal.fire({
        icon: "error",
        title: "Payment Failed",
        text: message,
        });
        setOpenModal(false);
    }
    };

    const handleOpenModal = (fee, student,monthId = null) => {
        setSelectedFee({ ...fee, student_id: student?.id, class_id: student?.class_id, month_id: monthId }); // ✅ student_id যোগ করা হলো
        setOpenModal(true);
    };
    

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedFee(null);
    };
    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

    const selectStyles = {
        control: (provided) => ({
          ...provided,
          height: 56, // Same as MUI TextField
          minHeight: 56,
          backgroundColor: "#ffffff", // White background
        }),
        menu: (provided) => ({
          ...provided,
          backgroundColor: "#ffffff", // Dropdown menu background white
          zIndex: 1000,
        }),
      };

      const handlePrint = async (studentId, feeType, category, monthId = null) => {
        try {
          let res;
      
          if (category !== "monthly") {
            res = await api.get(`https://dgps.co.in/api/student-invoice/${studentId}/${feeType}`);
          } else {
            const selectedMonthId = monthId || (new Date().getMonth() + 1).toString().padStart(2, '0');
            const formattedMonth = `${new Date().getFullYear()}-${selectedMonthId}`;
            res = await api.get(`https://dgps.co.in/api/student-invoice/${studentId}/${formattedMonth}`);
          }
      
          if (res.data.status) {
            const data = res.data.data;
      
            const printWindow = window.open();
      
            printWindow.document.write(`
              <html>
                <head>
                  <title>Fee Receipt</title>
                  <style>
                    body {
                      font-family: 'Segoe UI', sans-serif;
                      margin: 0;
                      padding: 20px;
                      background: #f4f6f9;
                    }
      
                    .receipt-box {
                      background: #fff;
                      border: 2px dashed #ccc;
                      border-radius: 12px;
                      padding: 10px;
                      margin: 20px;
                      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                      margin-bottom: 50px;
                    }
      
                    .school-header {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        gap: 10px;
                    }

                    .school-text {
                        flex-grow: 1;
                        text-align: center;
                    }

      
                    .school-logo {
                      width: 90px;
                      height: 90px;
                      object-fit: contain;
                    }
      
                    .school-name {
                      font-size: 22px;
                      font-weight: bold;
                      color: #002f6c;
                    }
      
                    .school-contact {
                      font-size: 12px;
                      color: #444;
                    }
      
                    .header {
                      background: #002f6c;
                      color: #fff;
                      text-align: center;
                      font-size: 20px;
                      font-weight: bold;
                      padding: 10px;
                      border-radius: 5px 5px 0 0;
                      
                    }
      
                    .copy-label {
                      text-align: center;
                      font-size: 12px;
                      color: #888;
                      margin: 10px 0 20px;
                    }
      
                    .section-title {
                      text-align: center;
                      font-weight: bold;
                      font-size: 16px;
                      margin: 20px 0 10px;
                      color: #002f6c;
                      border-bottom: 1px solid #ccc;
                      padding-bottom: 5px;
                    }
      
                    .info-row.single-row {
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      flex-wrap: nowrap;
                    }
      
                    .info-row.single-row p {
                      width: auto;
                      margin-right: 30px;
                      white-space: nowrap;
                      font-size: 14px;
                    }
      
                    .info-row {
                      display: flex;
                    }
      
                    .info-row p {
                      font-size: 14px;
                      margin: 5px 0;
                      width: 48%;
                    }
      
                    table {
                      width: 100%;
                      border-collapse: collapse;
                      margin-top: 15px;
                    }
      
                    th, td {
                      border: 1px solid #ccc;
                      padding: 10px;
                      font-size: 14px;
                    }
      
                    th {
                      background-color: #e2eefd;
                      text-align: left;
                    }
      
                    .footer {
                      text-align: center;
                      font-size: 12px;
                      color: #777;
                      margin-top: 20px;
                    }
      
                    @media print {
                      body {
                        background: white;
                        padding: 0;
                      }

                    }
                  </style>
                </head>
                <body>
                  <div class="receipt-container">
                    ${["Office Copy", "Student Copy"].map(copyType => `
                      <div class="receipt-box">
                        <div class="school-header">
                        <img src="https://dgps.co.in/public/admin/assets/img/logo.png" alt="School Logo" class="school-logo" />
                        
                        <div class="school-text">
                            <div class="school-name">Dormant Garden Public School</div>
                            <div class="school-contact">
                            Sattarpur, (Shitalatala), Chaitanyapur, Beldanga, Murshidabad, West Bengal, 742134<br>
                            Phone: +91 9732 573 514 | Email: dgps.co.in@gmail.com
                            </div>
                        </div>

                        </div>

      
                        <div class="header">Fee Receipt</div>
                        <div class="copy-label">${copyType}</div>
      
                        <div class="section-title">Student Details</div>
                        <div class="info-row single-row">
                          <p><strong>Student Name:</strong> ${data.student_name}</p>
                          <p><strong>Class:</strong> ${data.class_name} - ${data.section_name}</p>
                          <p><strong>Roll No:</strong> ${data.roll_no}</p>
                        </div>
      
                        <div class="section-title">Fee Details</div>
                        <table>
                          <thead>
                            <tr>
                              <th>Fee Type</th>
                              <th>Txn Id</th>
                              <th>Amount</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>${data.fee_type}</td>
                              <td>${data.txn_id}</td>
                              <td>₹ ${data.amount}</td>
                              <td>${data.payment_status}</td>
                            </tr>
                          </tbody>
                        </table>

                        <div class="info-row single-row">
                          <p><strong>Payment Date:</strong> ${data.payment_date || '-'}</p>
                          <p><strong>Collected By:</strong> ${data.collected_by_name || '-'}</p>
                        </div>
      
                        <div class="footer">
                          This is a system-generated receipt and doesn't require signature.
                        </div>
                      </div>
                    `).join("")}
                  </div>
      
                  <script>
                    window.onload = function() {
                      window.print();
                    };
                    window.onafterprint = function () {
                        window.close();
                    };
                  </script>
                </body>
              </html>
            `);
      
            printWindow.document.close();
          } else {
            alert("Invoice not found.");
          }
        } catch (error) {
          console.error("Print error:", error);
          alert("Something went wrong while generating the invoice.");
        }
      };
      
      
      
      
      
      

    // Fetch class list
    useEffect(() => {
        fetch("https://dgps.co.in/api/get-classes")
            .then(res => res.json())
            .then(data => setClassList(data.data))
            .catch(error => console.error("Error fetching classes:", error));
    }, []);

    // Fetch sections when class is selected
    useEffect(() => {
        if (selectedClass) {
            fetch(`https://dgps.co.in/api/get-sections/${selectedClass}`)
                .then(res => res.json())
                .then(data => setSections(data.data))
                .catch(error => console.error("Error fetching sections:", error));
        } else {
            setSections([]);
        }
    }, [selectedClass]);

    // Fetch roll numbers when section is selected
    useEffect(() => {
        if (selectedSection) {
            fetch(`https://dgps.co.in/api/get-rolls/${selectedSection}`)
                .then(res => res.json())
                .then(data => setRolls(data.data))
                .catch(error => console.error("Error fetching rolls:", error));
        } else {
            setRolls([]);
            setSelectedRoll(""); // Clear roll selection
        }
    }, [selectedSection]);

    // ✅ Optimized handleSearch Function
  const handleSearch = async () => {
    try {
      const params = {};
      if (searchTerm) params.query = searchTerm;
      if (selectedClass) params.class_id = selectedClass;
      if (selectedSection) params.section_id = selectedSection;
      if (selectedRoll) params.roll_no = selectedRoll;

      const res = await api.get("/search-student", { params });
      const data = res.data;
      if (data?.status && Array.isArray(data.students) && data.students.length > 0) {
        const s = data.students[0];
        setStudent(s);
        setPayments(s.payments || []);

        const combined = [
          ...(s.yearly_fees || []).map(f => ({ ...f, category: "yearly" })),
          ...(s.monthly_fees || []).map(f => ({ ...f, category: "monthly" }))
        ];
        setFees(combined);

        // map paid fees: monthly payments become monthly_fees_<monthIndex>
        const mappedPaid = (s.payments || []).map(p => {
          if (p.fee_type === "monthly_fees" && p.payment_status === "paid") {
            const monthPart = p.payment_month ? String(p.payment_month).split("-")[1] : null;
            const monthIndex = monthPart ? parseInt(monthPart, 10) : NaN;
            if (!isNaN(monthIndex) && monthIndex >= 1 && monthIndex <= 12) {
              return `monthly_fees_${monthIndex}`;
            }
            return `monthly_fees_unknown_${p.id || Math.random()}`;
          }
          return String(p.fee_type ?? p.id ?? "");
        });
        setPaidFees(mappedPaid);
      } else {
        setStudent(null);
        setPayments([]);
        setFees([]);
        setPaidFees([]);
      }
    } catch (err) {
      console.error("search-student error:", err?.response || err);
      // if 401 --> backend auth issue; show message
      if (err?.response?.status === 401) {
        Swal.fire({ icon: "error", title: "Unauthorized", text: "Session expired or invalid token. Please login again." }).then(() => {
          localStorage.clear();
          window.location.href = "/app/login";
        });
      }
    }
  };

    useEffect(() => {
        console.log("Paid Fees Mapping: ", paidFees);
    }, [paidFees]);
    
    
    // ✅ মাসের নামগুলোর জন্য গ্লোবাল অ্যারে (ফাংশনের বাইরে ডিক্লেয়ার করা)
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // ✅ `useEffect` to Update `filteredFees` (Optimize and Clean)
    useEffect(() => {
        let updatedFees = fees.filter(fee => fee.category !== "monthly");

        if (student?.monthly_payment > 0) {
            let monthlyFees = months.map((month, index) => {
                const feeId = `monthly_fees_${index + 1}`;
                return {
                    id: feeId,
                    fee_type: `Monthly Fees - ${month}`,
                    amount: student.monthly_payment,
                    category: "monthly",
                    isPaid: paidFees.includes(feeId),
                };
            });

            updatedFees = [...updatedFees, ...monthlyFees];
        }

        setFilteredFees(updatedFees);
        console.log("update fees", updatedFees);
    }, [fees, student, paidFees]); // ✅ Add `paidFees` dependency here
    

    // ✅ Simplified Check if Fee is Paid
    const checkIfPaid = (fee) => {
        return paidFees.includes(fee.id);  // ✅ Checking the fee ID directly
    };
    



    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", marginTop: "0px" }}>
            <div style={{ display: "flex", flex: 1 }}>
                <div className="p-5" style={{ flex: 1, margin: "5px" }}>

                    {/* Filter Section */}
                    <Paper elevation={4} style={{
                                padding: "20px",
                                borderRadius: "12px",
                                background: "#f9f9f9",
                                marginBottom: "10px"
                            }}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <Autocomplete
                                    options={classList}
                                    getOptionLabel={(option) => option.class_name}
                                    value={classList.find((cls) => cls.id === selectedClass) || null}
                                    onChange={(event, newValue) => {
                                        setSelectedClass(newValue ? newValue.id : "");
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Class"
                                            fullWidth
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {selectedClass && (
                                                            <IconButton
                                                                onClick={() => setSelectedClass("")}
                                                                edge="end"
                                                                size="small"
                                                            >
                                                            </IconButton>
                                                        )}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* Section Selection */}
                            <Grid item xs={4}>
                                <Autocomplete
                                    options={selectedClass ? sections : []}
                                    getOptionLabel={(option) => option.section_name}
                                    value={sections.find((sec) => sec.id === selectedSection) || null}
                                    onChange={(event, newValue) => {
                                        setSelectedSection(newValue ? newValue.id : "");
                                    }}
                                    disabled={!selectedClass}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Section"
                                            fullWidth
                                            disabled={!selectedClass}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {selectedSection && (
                                                            <IconButton
                                                                onClick={() => setSelectedSection("")}
                                                                edge="end"
                                                                size="small"
                                                            >
                                                            </IconButton>
                                                        )}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            {/* Roll Number Selection */}
                            <Grid item xs={4}>
                                <Autocomplete
                                    options={selectedSection ? rolls : []}
                                    getOptionLabel={(option) => option.roll_no} // Convert to string
                                    value={rolls.find((roll) => roll.roll_no === selectedRoll) || null}
                                    onChange={(event, newValue) => {
                                        setSelectedRoll(newValue ? newValue.roll_no : "");
                                    }}
                                    disabled={!selectedSection}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Select Roll Number"
                                            fullWidth
                                            disabled={!selectedSection}
                                            InputProps={{
                                                ...params.InputProps,
                                                endAdornment: (
                                                    <>
                                                        {selectedRoll && (
                                                            <IconButton
                                                                onClick={() => setSelectedRoll("")}
                                                                edge="end"
                                                                size="small"
                                                            >
                                                            </IconButton>
                                                        )}
                                                        {params.InputProps.endAdornment}
                                                    </>
                                                ),
                                            }}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={4}>
                                <TextField
                                    fullWidth
                                    label="Search (Name, Mobile, ID)"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    InputProps={{
                                    endAdornment: (
                                        <>
                                        {searchTerm && (
                                            <IconButton
                                            onClick={() => setSearchTerm("")}
                                            edge="end"
                                            size="small"
                                            >
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                        </>
                                    ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4} style={{ display: "flex", justifyContent: "center" }}>
                                <Button
                                    variant="contained"
                                    onClick={handleSearch}
                                    startIcon={<SearchIcon />}
                                    style={{
                                    background: "linear-gradient(90deg, #4e54c8 0%, #8f94fb 100%)",
                                    color: "#fff",
                                    padding: "12px 30px",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    borderRadius: "12px",
                                    textTransform: "none",
                                    boxShadow: "0 8px 16px rgba(78, 84, 200, 0.3)",
                                    transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                    }}
                                    onMouseOver={(e) => {
                                    e.currentTarget.style.transform = "scale(1.05)";
                                    e.currentTarget.style.boxShadow = "0 12px 20px rgba(78, 84, 200, 0.5)";
                                    }}
                                    onMouseOut={(e) => {
                                    e.currentTarget.style.transform = "scale(1)";
                                    e.currentTarget.style.boxShadow = "0 8px 16px rgba(78, 84, 200, 0.3)";
                                    }}
                                >
                                    Search Student
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>

                    {/* Student Details & Fees */}
                    <Grid container spacing={2}>
                        {/* Student Details Section */}
                        <Grid item xs={12} sm={12} md={4}>
                            <Paper elevation={4} style={{ padding: "20px", borderRadius: "12px", background: "#f9f9f9" }}>
                                <Typography variant="h6" gutterBottom style={{ fontWeight: "bold", textAlign: "center", color: "#333", borderBottom: "2px solid #3f51b5", paddingBottom: "8px", marginBottom: "10px" }}>
                                🎓 Student Details
                                </Typography>

                                {student?.file ? (
                                    <div style={{ display: "flex", justifyContent: "center", marginBottom: "15px" }}>
                                        <img
                                        src={student.file}
                                        alt="Student"
                                        style={{
                                            width: "120px",
                                            height: "120px",
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                            border: "2px solid #3f51b5",
                                        }}
                                        />
                                    </div>
                                    ) : (
                                    <div style={{ textAlign: "center", marginBottom: "15px", color: "#888" }}>
                                        <Typography variant="body2" style={{ fontStyle: "italic" }}>
                                        No Photo Available
                                        </Typography>
                                    </div>
                                )}

                                {student ? (
                                    
                                    <div style={{ display: "grid", gap: "8px" }}>
                                        {renderDetail("🆔 Student ID", student.student_code)}
                                        {renderDetail("👤 Name", student.name)}
                                        {renderDetail("🏫 Class", student.class)}
                                        {renderDetail("📚 Section", student.section)}
                                        {renderDetail("🔢 Roll No", student.roll_no)}
                                        {renderDetail("📞 Mobile", student.mobile)}
                                    </div>
                                ) : (
                                    <Typography variant="body1" style={{ textAlign: "center", color: "#777", fontStyle: "italic", paddingTop: "10px" }}>
                                        No Student Selected
                                    </Typography>
                                )}
                            </Paper>
                        </Grid>

                        {/* Fee Details Section */}
                        <Grid item xs={12} sm={12} md={8}>
                   
                            <Paper elevation={4} style={{ padding: "20px", borderRadius: "12px", background: "#f9f9f9" }}>
                                <Typography
                                    variant="h6"
                                    style={{
                                        fontWeight: "bold",
                                        textAlign: "center",
                                        color: "#333",
                                        borderBottom: "2px solid #3f51b5",
                                        paddingBottom: "8px",
                                        marginBottom: "15px",
                                    }}
                                >
                                    💰 Fee Details
                                </Typography>

                                {filteredFees.length > 0 ? (
                                    <>
                                        {/* ✅ প্রথম Row - Regular Fees */}
                                        <Grid container spacing={2}>
                                            {filteredFees
                                                .filter(fee => fee.category !== "monthly") // ✅ Regular Fees filter
                                                .map((fee) => {
                                                    const isPaid = checkIfPaid(fee);

                                                    return (
                                                        <Grid item xs={12} sm={6} md={3} key={fee.id}>
                                                            <Paper
                                                                elevation={2}
                                                                style={{
                                                                    padding: "20px",
                                                                    borderRadius: "16px",
                                                                    textAlign: "center",
                                                                    background: isPaid ? "linear-gradient(135deg, #e0f2f1, #e8f5e9)" : "#ffffff",
                                                                    border: isPaid ? "1px solid #81c784" : "1px solid #e0e0e0",
                                                                    boxShadow: isPaid
                                                                      ? "0 8px 20px rgba(129, 199, 132, 0.3)"
                                                                      : "0 6px 12px rgba(0, 0, 0, 0.06)",
                                                                    transition: "all 0.3s ease-in-out",
                                                                    backdropFilter: "blur(4px)",
                                                                    WebkitBackdropFilter: "blur(4px)",
                                                                  }}
                                                            >
                                                                <Typography variant="body1" style={{ fontWeight: "bold", color: "#333" }}>
                                                                    {fee.fee_type}
                                                                </Typography>
                                                                <Typography variant="h6" style={{ color: "#3f51b5", margin: "5px 0" }}>
                                                                    ₹ {fee.amount}
                                                                </Typography>

                                                                {isPaid ? (
                                                                    <div
                                                                        style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        gap: "10px",
                                                                        marginTop: "12px",
                                                                        }}
                                                                    >
                                                                        <CheckCircleIcon style={{ color: "#4caf50", fontSize: 28 }} />
                                                                        <Button
                                                                            variant="outlined"
                                                                            color="success"
                                                                            size="small"
                                                                            onClick={() => handlePrint(student.id, fee.id, fee.category)}
                                                                            startIcon={<PrintIcon />}
                                                                            style={{
                                                                                borderRadius: "12px",
                                                                                fontWeight: 600,
                                                                                padding: "6px 16px",
                                                                                border: "1px solid #4caf50",
                                                                                color: "#4caf50",
                                                                                backgroundColor: "#e8f5e9",
                                                                                boxShadow: "0 2px 8px rgba(76, 175, 80, 0.2)",
                                                                                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                                                                }}
                                                                                onMouseOver={(e) => {
                                                                                e.currentTarget.style.transform = "scale(1.05)";
                                                                                e.currentTarget.style.boxShadow = "0 12px 20px rgba(78, 84, 200, 0.5)";
                                                                                }}
                                                                                onMouseOut={(e) => {
                                                                                e.currentTarget.style.transform = "scale(1)";
                                                                                e.currentTarget.style.boxShadow = "0 8px 16px rgba(78, 84, 200, 0.3)";
                                                                                }}
                                                                            >
                                                                            Print
                                                                        </Button>
                                                                    </div>
                                                                    ) : (
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        size="small"
                                                                        onClick={() => handleOpenModal(fee, student)}
                                                                        startIcon={<PaymentIcon />}
                                                                        style={{
                                                                        borderRadius: "12px",
                                                                        fontWeight: 600,
                                                                        padding: "6px 20px",
                                                                        boxShadow: "0 4px 12px rgba(63, 81, 181, 0.3)",
                                                                        marginTop: "12px",
                                                                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                                                        }}
                                                                        onMouseOver={(e) => {
                                                                        e.currentTarget.style.transform = "scale(1.05)";
                                                                        e.currentTarget.style.boxShadow = "0 12px 20px rgba(78, 84, 200, 0.5)";
                                                                        }}
                                                                        onMouseOut={(e) => {
                                                                        e.currentTarget.style.transform = "scale(1)";
                                                                        e.currentTarget.style.boxShadow = "0 8px 16px rgba(78, 84, 200, 0.3)";
                                                                        }}
                                                                    >
                                                                        Pay Now
                                                                    </Button>
                                                                )}

                                                            </Paper>
                                                        </Grid>
                                                    );
                                                })}
                                        </Grid>

                                        {/* ✅ দ্বিতীয় Row - Monthly Fees */}
                                        <Typography
                                            variant="h6"
                                            style={{
                                                fontWeight: "bold",
                                                textAlign: "center",
                                                color: "#3f51b5",
                                                borderBottom: "2px solid #3f51b5",
                                                paddingBottom: "8px",
                                                marginBottom: "15px",
                                            }}
                                        >
                                            📆 Monthly Fees
                                        </Typography>

                                        <Grid container spacing={2}>
                                            {filteredFees
                                                .filter(fee => fee.category === "monthly") // ✅ Monthly Fees filter
                                                .map((fee) => {
                                                    const isPaid = checkIfPaid(fee);

                                                    let monthId = "00"; // Default value
                                                    const monthIndex = months.findIndex(m => fee.fee_type.includes(m));
                                                    if (monthIndex !== -1) {
                                                        monthId = String(monthIndex + 1).padStart(2, "0");
                                                    }

                                                    return (
                                                        <Grid item xs={12} sm={6} md={3} key={fee.id}>
                                                            <Paper
                                                                elevation={2}
                                                                style={{
                                                                    padding: "20px",
                                                                    borderRadius: "16px",
                                                                    textAlign: "center",
                                                                    //minHeight: "100px",
                                                                    background: isPaid ? "linear-gradient(135deg, #e0f2f1, #e8f5e9)" : "#ffffff",
                                                                    border: isPaid ? "1px solid #81c784" : "1px solid #e0e0e0",
                                                                    boxShadow: isPaid
                                                                      ? "0 8px 20px rgba(129, 199, 132, 0.3)"
                                                                      : "0 6px 12px rgba(0, 0, 0, 0.06)",
                                                                    transition: "all 0.3s ease-in-out",
                                                                    backdropFilter: "blur(4px)",
                                                                    WebkitBackdropFilter: "blur(4px)",
                                                                  }}
                                                            >
                                                                <Typography variant="body1" style={{ fontWeight: "bold", color: "#333" }}>
                                                                    {fee.fee_type}
                                                                </Typography>
                                                                <Typography variant="h6" style={{ color: "#3f51b5", margin: "5px 0" }}>
                                                                    ₹ {fee.amount}
                                                                </Typography>

                                                                {isPaid ? (
                                                                    <div
                                                                        style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        gap: "10px",
                                                                        marginTop: "12px",
                                                                        }}
                                                                    >
                                                                        <CheckCircleIcon style={{ color: "#4caf50", fontSize: 28 }} />
                                                                        <Button
                                                                            variant="outlined"
                                                                            color="success"
                                                                            size="small"
                                                                            onClick={() => handlePrint(student.id, fee.id, fee.category, monthId)}
                                                                            startIcon={<PrintIcon />}
                                                                            style={{
                                                                                borderRadius: "12px",
                                                                                fontWeight: 600,
                                                                                padding: "6px 16px",
                                                                                border: "1px solid #4caf50",
                                                                                color: "#4caf50",
                                                                                backgroundColor: "#e8f5e9",
                                                                                boxShadow: "0 2px 8px rgba(76, 175, 80, 0.2)",
                                                                                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                                                                }}
                                                                                onMouseOver={(e) => {
                                                                                e.currentTarget.style.transform = "scale(1.05)";
                                                                                e.currentTarget.style.boxShadow = "0 12px 20px rgba(78, 84, 200, 0.5)";
                                                                                }}
                                                                                onMouseOut={(e) => {
                                                                                e.currentTarget.style.transform = "scale(1)";
                                                                                e.currentTarget.style.boxShadow = "0 8px 16px rgba(78, 84, 200, 0.3)";
                                                                                }}
                                                                        >
                                                                        Print
                                                                        </Button>
                                                                    </div>
                                                                    ) : (
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        size="small"
                                                                        onClick={() => handleOpenModal(fee, student, monthId)}
                                                                        startIcon={<PaymentIcon />}
                                                                        style={{
                                                                        borderRadius: "12px",
                                                                        fontWeight: 600,
                                                                        padding: "6px 20px",
                                                                        boxShadow: "0 4px 12px rgba(63, 81, 181, 0.3)",
                                                                        marginTop: "12px",
                                                                        transition: "transform 0.2s ease, box-shadow 0.2s ease",
                                                                        }}
                                                                        onMouseOver={(e) => {
                                                                        e.currentTarget.style.transform = "scale(1.05)";
                                                                        e.currentTarget.style.boxShadow = "0 12px 20px rgba(78, 84, 200, 0.5)";
                                                                        //e.currentTarget.style.backgroundColor= "#e3f2fd";
                                                                        }}
                                                                        onMouseOut={(e) => {
                                                                        e.currentTarget.style.transform = "scale(1)";
                                                                        e.currentTarget.style.boxShadow = "0 8px 16px rgba(78, 84, 200, 0.3)";
                                                                        }}
                                                                  
                                                                    >
                                                                        Pay Now
                                                                    </Button>
                                                                )}

                                                            </Paper>
                                                        </Grid>
                                                    );
                                                })}
                                        </Grid>;
                                    </>
                                ) : (
                                    <Typography
                                        variant="body1"
                                        style={{ textAlign: "center", color: "#777", fontStyle: "italic", paddingTop: "10px" }}
                                    >
                                        No Fees Available
                                    </Typography>
                                )}
                            </Paper>

                            {/* Payment Modal */}
                            <Modal open={openModal} onClose={handleCloseModal}>
                                <Box style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: 400, backgroundColor: "white", boxShadow: 24, padding: "20px", borderRadius: "10px", textAlign: "center" }}>
                                            {/* Close Button */}
                                        <IconButton
                                        onClick={handleCloseModal}
                                        style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                            color: "#555",
                                        }}
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                    <Typography variant="h6" gutterBottom>Confirm Payment</Typography>

                                    {selectedFee && (
                                        <>
                                            <Typography variant="body1">
                                                <strong>Fee Type:</strong> {selectedFee.fee_type}
                                            </Typography>

                                            {selectedFee.fee_type === "MEAL CHARGE" ? (
                                                <>
                                                    <TextField
                                                        label="Total Days"
                                                        type="number"
                                                        fullWidth
                                                        value={totalDays}
                                                        onChange={(e) => setTotalDays(e.target.value)}
                                                        margin="normal"
                                                    />
                                                    <Typography variant="body1">
                                                        <strong>Rate per Day:</strong> ₹ {selectedFee.amount} 
                                                    </Typography>
                                                    <Typography variant="h6" color="primary" style={{ margin: "10px 0" }}>
                                                    ₹ {totalDays * selectedFee.amount}
                                                    </Typography>
                                                </>
                                            ) : (
                                                <Typography variant="h6" color="primary" style={{ margin: "10px 0" }}>
                                                    ₹ {selectedFee.amount}
                                                </Typography>
                                            )}

                                            <TextField
                                                select
                                                label="Payment Mode"
                                                fullWidth
                                                value={paymentMode}
                                                onChange={(e) => setPaymentMode(e.target.value)}
                                                margin="normal"
                                                InputProps={{
                                                    endAdornment: paymentMode ? (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                        onClick={() => setPaymentMode("")}
                                                        edge="end"
                                                        size="small"
                                                        >
                                                        <ClearIcon fontSize="small" />
                                                        </IconButton>
                                                    </InputAdornment>
                                                    ) : null,
                                                }}
                                                >
                                                <MenuItem value="cash">Cash</MenuItem>
                                                <MenuItem value="upi">UPI</MenuItem>
                                            </TextField>

                                            {paymentMode === "upi" && (
                                                <TextField label="UTR Number" fullWidth value={utrNumber} onChange={(e) => setUtrNumber(e.target.value)} margin="normal" />
                                            )}

                                            <Button variant="contained" color="success" fullWidth onClick={handleSubmit} disabled={!paymentMode}>
                                                Proceed to Pay
                                            </Button>
                                        </>
                                    )}
                                </Box>
                            </Modal>

                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    );
};

export default StudentBill;

const renderDetail = (label, value) => (
    <div style={{
        display: "flex",
        justifyContent: "space-between",
        background: "#fff",
        padding: "8px 12px",
        borderRadius: "8px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        fontSize: "14px"
    }}>
        <Typography variant="body2" style={{ fontWeight: "bold", color: "#444" }}>
            {label}:
        </Typography>
        <Typography variant="body2" style={{ color: "#222", fontWeight: "600" }}>
            {value}
        </Typography>
    </div>
);


